// src/components/PaymentFlow/InstallmentRow.js

import React from 'react';
import { formatCurrency, formatDate } from '../../utils/numberFormatter';

const InstallmentRow = ({ installment, loanId, onInstallmentSelection }) => {
  const isOverdue = new Date(installment.dates.due_date) < new Date();
  const isPaid = installment.status.code == 3;

  return (
    <tr className="mb-0 small">
      <td>{installment.number}</td>
      <td>{formatDate(installment.dates.due_date,2)}</td>
      <td>{formatCurrency(installment.financial.total,2)}</td>
      <td className={isOverdue && !isPaid ? 'text-danger' : ''}>
        {installment.financial.punitives.total ? formatCurrency(installment.financial.punitives.total,2) : '-'}
      </td>
      <td>{formatCurrency(installment.balance.paid.total,2)}</td>
      <td>
        {isPaid ? (
          <span className="badge bg-success">Pagado</span>
        ) : (
          <span className={isOverdue ? 'text-danger' : ''}>
            {formatCurrency(installment.balance.remain.total,2)}
          </span>
        )}
      </td>
    </tr>
  );
};

export default InstallmentRow;
